import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getProjectFromProps } from './withProjectContextProvider';
import ProjectContext from './ProjectContext';

const ProjectContextProvider = ({ children, project, scale }) => {
  const contextValues = useMemo(
    () => ({ project: getProjectFromProps({ project, scale }) }),
    [project, scale]
  );

  return (
    <ProjectContext.Provider value={contextValues}>
      {children}
    </ProjectContext.Provider>
  );
};

ProjectContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  project: PropTypes.object,
  scale: PropTypes.string
};

export default ProjectContextProvider;
